module.exports = __webpack_public_path__ + "img/weddings_18_V.97200a84.webp";